export type Donation = {
  ein: string;
  name: string;
  amount: number;
  message: string;
  instructions: {
    type: string[];
    contact: {
      name: string;
      phone: string;
      email: string;
    };
    address: {
      name: string;
      street: string;
      unit: string;
      city: string;
      state: string;
      zip: string;
    };
    optIn: {
      accept: boolean;
      email: string;
      name: string;
    };
    attribution: string;
    designation: string;
    notes: string;
  };
};

export const DefaultDonation: Donation = {
  ein: "",
  name: "",
  amount: 0,
  message: "",
  instructions: {
    type: [],
    contact: {
      name: "",
      phone: "",
      email: "",
    },
    address: {
      name: "",
      street: "",
      unit: "",
      city: "",
      state: "",
      zip: "",
    },
    optIn: {
      accept: false,
      email: "",
      name: "",
    },
    attribution: "",
    designation: "",
    notes: "",
  },
};
